"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDayNumber = void 0;
var moment = require("moment");
exports.formatDayNumber = function (number, short) {
    var stringFormat = short ? "ddd" : "dddd";
    return moment()
        .day(number)
        .format(stringFormat);
};
//# sourceMappingURL=format-day-number.js.map